export class MapUtils {

  public static convertFromObjectToMap(obj): Map<any, any> {
    const map = new Map();
    const keys = Object.keys(obj);
    for (let i = 0; i < keys.length; i++) {
      //inserting new key value pair inside map
      map.set(keys[i], obj[keys[i]]);
    }
    return map;
  }

  public static convertFromMapToObject(map) {
    let obj = Object.create(null);
    map.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }
}
